import Vue from 'vue'
import Router from 'vue-router'
import Login from 'pages/common/components/login/index'
import Aggrement from 'pages/common/components/login/aggrement'

import Index from 'pages/common/components/index'
import Pay from 'pages/common/components/pay/index'
import PayCCIC from 'pages/common/components/pay/indexDadi'

import PayError from 'pages/common/components/pay/Error'
// 仓小微支付
import NewPay from 'pages/common/components/pay/IndexNew'
// 云立方支付
import YunPay from 'pages/common/components/pay/IndexYun'
// 支付成功
import PaySuccess from 'pages/common/components/pay/Success'
import paySuccessCCIC from 'pages/common/components/pay/successDadi'

// 通用框架支付
import CommonPay from 'pages/common/components/pay/IndexCommon'


Vue.use(Router)

export default new Router({
    routes: [
        {
            path: '/',
            name: 'Index',
            component: Index
        },
        {
        	path:'/login',
        	name:'login',
            component:Login
        },
        {
        	path:'/aggrementProtocol/:type',
        	name:'Aggrement',
            component:Aggrement
        },
        {
            path:'/pay',
            name:'pay',
            component:Pay
        },
        {
            path:'/payCCIC',
            name:'payCCIC',
            component:PayCCIC
        },
        {
            path:'/pay-error',
            name:'payError',
            component:PayError
        },
        {
            path:'/new-pay',
            name:'newPay',
            component:NewPay
        },
		{
            path:'/yun-pay',
            name:'yunPay',
            component:YunPay
        },
        {
            path:'/pay-success/:id?',
            component:PaySuccess
        },
        {
            path:'/paySuccessCCIC/:id?',
            component:paySuccessCCIC
        },
        {
            path:'/common-pay/:id',
            name:'commonPay',
            component:CommonPay
        },
    ]
})



// WEBPACK FOOTER //
// ./src/pages/common/router/index.js